import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageViewed } from "@/lib/analytics";

export const ScrollRestoration = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageViewed(pathname + search);
  }, [pathname, search]);

  return null;
};
